module.exports = __webpack_public_path__ + "static/media/casting_la_soul.68fbffa0.jpg";